import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastTypes, useMessage } from '../../../base/context/MessageProvider';
import { SiAmazon, SiFlipkart } from 'react-icons/si';
import SellerFlipkartProductDetail from '../flipkartProduct/FlipkartProductDetail';
import SellerAmazonProductDetail from '../amazonProduct/AmazonProductDetail';
import './productResearch.css';

// const MyntraIcon = ({ size = 16 }) => (
//   <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: size, height: size, borderRadius: '3px', background: '#FF3F6C', color: '#fff', fontSize: size * 0.75, fontWeight: 800, lineHeight: 1 }}>
//     M
//   </span>
// );

const PLATFORMS = [
  { value: 'amazon',   label: 'Amazon',   Icon: ({ size }) => <SiAmazon size={size} />,   color: '#FF9900' },
  { value: 'flipkart', label: 'Flipkart', Icon: ({ size }) => <SiFlipkart size={size} />, color: '#2874F0' },
  // { value: 'myntra',   label: 'Myntra',   Icon: ({ size }) => <MyntraIcon size={size} />, color: '#FF3F6C' },
];

const extractAmazonAsin = (input) => {
  if (!input) return '';
  const value = input.trim();

  // Allow raw ASIN input directly.
  if (/^[A-Z0-9]{10}$/i.test(value)) {
    return value.toUpperCase();
  }

  const patterns = [
    /\/dp\/([A-Z0-9]{10})/i,
    /\/gp\/product\/([A-Z0-9]{10})/i,
    /\/product\/([A-Z0-9]{10})/i,
    /[?&]asin=([A-Z0-9]{10})/i,
  ];

  for (const pattern of patterns) {
    const match = value.match(pattern);
    if (match?.[1]) return match[1].toUpperCase();
  }

  try {
    const parsed = new URL(value);
    const asinFromQuery = parsed.searchParams.get('asin') || parsed.searchParams.get('ASIN');
    if (asinFromQuery && /^[A-Z0-9]{10}$/i.test(asinFromQuery)) {
      return asinFromQuery.toUpperCase();
    }
  } catch {
    // Ignore parse errors; handled by empty return.
  }

  return '';
};

export default function SellerProductResearch() {
  const navigate = useNavigate();
  const message = useMessage();
  const [platform, setPlatform] = useState('amazon');
  const [productUrl, setProductUrl] = useState('');
  const [flipkartUrl, setFlipkartUrl] = useState(null);
  const [amazonAsin, setAmazonAsin] = useState(null);

  const activePlatform = PLATFORMS.find((p) => p.value === platform);

  const handleSearch = (e) => {
    e.preventDefault();

    const trimmedUrl = productUrl.trim();
    if (!trimmedUrl) {
      message.showToast('Please enter a product URL', ToastTypes.WARNING);
      return;
    }

    if (platform === 'amazon') {
      const asin = extractAmazonAsin(trimmedUrl);
      if (!asin) {
        message.showToast('Invalid Amazon URL or ASIN', ToastTypes.ERROR);
        return;
      }

      setAmazonAsin(asin);
      setFlipkartUrl(null);
      return;
    }

    if (platform === 'flipkart') {
      // Validate it's a Flipkart URL
      if (!trimmedUrl.includes('flipkart.com') && !trimmedUrl.includes('dl.flipkart.com')) {
        message.showToast('Please enter a valid Flipkart product URL', ToastTypes.ERROR);
        return;
      }

      setFlipkartUrl(trimmedUrl);
      setAmazonAsin(null);
      return;
    }

    message.showToast(`${activePlatform?.label || platform} URL search is not integrated yet`, ToastTypes.INFO);
  };

  return (
    <div className="pr-wrapper">
      <div className="pr-card">

        {/* Header row */}
        <div className="pr-header">
          <div className="pr-title-group">
            <h2 className="pr-title">Product Research</h2>
            <span className="pr-subtitle">Select a marketplace and search by product URL.</span>
          </div>

          <div className="pr-tabs">
            {PLATFORMS.map(({ value, label, Icon, color }) => (
              <button
                key={value}
                type="button"
                onClick={() => setPlatform(value)}
                className={`pr-tab${platform === value ? ' active' : ''}`}
                style={{ '--pr-accent': color }}
              >
                <Icon size={14} />
                {label}
              </button>
            ))}
          </div>
        </div>

        {/* Search form */}
        <form onSubmit={handleSearch} className="pr-form">
          <input
            type="text"
            value={productUrl}
            onChange={(e) => setProductUrl(e.target.value)}
            placeholder={platform === 'amazon' ? 'Search by Amazon URL or ASIN' : `Search by ${activePlatform?.label || platform} product URL`}
            className="pr-input"
          />
          <button type="submit" className="pr-btn">Search</button>
        </form>
      </div>

      {amazonAsin && (
        <div className="pr-result">
          <SellerAmazonProductDetail asin={amazonAsin} isEmbedded />
        </div>
      )}

      {flipkartUrl && (
        <div className="pr-result">
          <SellerFlipkartProductDetail url={flipkartUrl} />
        </div>
      )}
    </div>
  );
}
